import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({children}) => {
  const user = localStorage.getItem("user_token");
  return user ? children : <Navigate to={"/"} />;
};

export default PrivateRoute;